import React from 'react'

const Cp_map = () => {
    return (
        <div className='container'>
            <tr><td>



<h1 class="h1">C++ map function</h1>
<p>Maps are part of the C++ STL (Standard Template Library). Maps are the associative containers that store sorted key-value pair, in which each key is unique and it can be inserted or deleted but cannot be altered. Values associated with keys can be changed.</p>
<p><strong>For example:</strong> A map of Employees where employee ID is the key and name is the value can be represented as:</p>
<table class="alt">
<tbody><tr>
    <th>Keys</th>
    <th>Values</th>
</tr>
<tr>
    <td>101</td>
    <td>Nikita</td>
</tr>
<tr>
    <td>102</td>
    <td>Robin</td>
</tr>
<tr>
    <td>103</td>
    <td>Deep</td>
</tr>
<tr>
    <td>104</td>
    <td>John</td>
</tr>
</tbody></table>
<h2 class="h2">Syntax</h2>
<div class="containers"><div class="dp-highlighter"><div class="bar"><div class="touls"></div></div><ul start="1" class="dp-cpp" ><li  class="alt"><span><span class="keyword">template</span><span>&nbsp;&lt;&nbsp;</span><span class="keyword">class</span><span>&nbsp;Key,&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span class="comment">//&nbsp;map::key_type</span><span>&nbsp;&nbsp;</span></span></li><li  class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="keyword">class</span><span>&nbsp;T,&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span class="comment">//&nbsp;map::mapped_type</span><span>&nbsp;&nbsp;</span></span></li><li  class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="keyword">class</span><span>&nbsp;Compare&nbsp;=&nbsp;less&lt;Key&gt;,&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span class="comment">//&nbsp;map::key_compare</span><span>&nbsp;&nbsp;</span></span></li><li  class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="keyword">class</span><span>&nbsp;Alloc&nbsp;=&nbsp;allocator&lt;pair&lt;</span><span class="keyword">const</span><span>&nbsp;Key,T&gt;&nbsp;&gt;&nbsp;&nbsp;&nbsp;&nbsp;</span><span class="comment">//&nbsp;map::allocator_type</span><span>&nbsp;&nbsp;</span></span></li><li  class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&gt;&nbsp;<span class="keyword">class</span><span>&nbsp;map;&nbsp;&nbsp;</span></span></li></ul></div>template &lt; class Key,                                             // map::key_type
           class T,                                                     // map::mapped_type
           class Compare = less&lt;Key&gt;,                        // map::key_compare
           class Alloc = allocator&lt;pair&lt;const Key,T&gt; &gt;    // map::allocator_type
           &gt; class map;
</div>
<h2 class="h3">Parameter</h2>
<p><strong>key:</strong> The key data type to be stored in the map.</p>
<p><strong>type:</strong> The data type of value to be stored in the map.</p>
<p><strong>compare:</strong> A comparison class that takes two arguments of the same type boul and returns a value. This argument is optional and the binary predicate less&lt;"key"&gt; is the default value.</p> 
<p><strong>alloc:</strong> Type of the allocator object. This argument is optional and the default value is allocator <value_type>.</value_type></p>
<h2 class="h3">Creating a map</h2>
<p>Maps can easily be created using the fullowing statement:</p>
<div class="containers">
    <div class="dp-highlighter">
        <div class="bar">
            <div class="touls"></div>
        </div>
        <ul start="1" class="dp-cpp" >
            <li  class="alt"><span><span class="keyword">typedef</span><span>&nbsp;pair&lt;</span><span
                        class="keyword">const</span><span>&nbsp;Key,&nbsp;T&gt;&nbsp;value_type;&nbsp;&nbsp;</span></span>
            </li>
        </ul>
    </div>

</div>
<p>The above form will use to create a map with key of type <strong>Key type</strong> and value of type <strong>value type.</strong> One important thing is that key of a map and corresponding values are always inserted as a pair, you cannot insert only key or just a value in a map.</p>
<h2 class="h3">Example 1</h2>
<div class="containers">
    <div class="dp-highlighter">
        <div class="bar">
            <div class="touls"></div>
        </div>
        <ul start="1" class="dp-cpp" >
            <li  class="alt"><span><span
                        class="preprocessor">#include&nbsp;&lt;string.h&gt;</span><span>&nbsp;&nbsp;</span></span></li>
            <li  class=""><span><span
                        class="preprocessor">#include&nbsp;&lt;iostream&gt;</span><span>&nbsp;&nbsp;</span></span></li>
            <li  class="alt"><span><span
                        class="preprocessor">#include&nbsp;&lt;map&gt;</span><span>&nbsp;&nbsp;</span></span></li>
            <li  class=""><span><span
                        class="preprocessor">#include&nbsp;&lt;utility&gt;</span><span>&nbsp;&nbsp;</span></span></li>
            <li  class="alt"><span><span class="keyword">using</span><span>&nbsp;</span><span
                        class="keyword">namespace</span><span>&nbsp;std;&nbsp;&nbsp;</span></span></li>
            <li  class=""><span><span class="datatypes">int</span><span>&nbsp;main()&nbsp;&nbsp;</span></span></li>
            <li  class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
            <li  class=""><span>&nbsp;&nbsp;&nbsp;map&lt;<span
                        class="datatypes">int</span><span>,&nbsp;string&gt;&nbsp;Employees;&nbsp;&nbsp;</span></span>
            </li>
            <li  class="alt"><span>&nbsp;&nbsp;&nbsp;<span
                        class="comment">//&nbsp;1)&nbsp;Assignment&nbsp;using&nbsp;array&nbsp;index&nbsp;notation</span><span>&nbsp;&nbsp;</span></span>
            </li>
            <li  class=""><span>&nbsp;&nbsp;&nbsp;Employees[101]&nbsp;=&nbsp;<span
                        class="string">"Nikita"</span><span>;&nbsp;&nbsp;</span></span></li>
            <li  class="alt"><span>&nbsp;&nbsp;&nbsp;Employees[105]&nbsp;=&nbsp;<span
                        class="string">"John"</span><span>;&nbsp;&nbsp;</span></span></li>
            <li  class=""><span>&nbsp;&nbsp;&nbsp;Employees[103]&nbsp;=&nbsp;<span
                        class="string">"Dully"</span><span>;&nbsp;&nbsp;</span></span></li>
            <li  class="alt"><span>&nbsp;&nbsp;&nbsp;Employees[104]&nbsp;=&nbsp;<span
                        class="string">"Deep"</span><span>;&nbsp;&nbsp;</span></span></li>
            <li  class=""><span>&nbsp;&nbsp;&nbsp;Employees[102]&nbsp;=&nbsp;<span
                        class="string">"Aman"</span><span>;&nbsp;&nbsp;</span></span></li>
            <li  class="alt"><span>&nbsp;&nbsp;&nbsp;cout&nbsp;&lt;&lt;&nbsp;<span
                        class="string">"Employees[104]="</span><span>&nbsp;&lt;&lt;&nbsp;Employees[104]&nbsp;&lt;&lt;&nbsp;endl&nbsp;&lt;&lt;&nbsp;endl;&nbsp;&nbsp;</span></span>
            </li>
            <li  class=""><span>&nbsp;&nbsp;&nbsp;cout&nbsp;&lt;&lt;&nbsp;<span
                        class="string">"Map&nbsp;size:&nbsp;"</span><span>&nbsp;&lt;&lt;&nbsp;Employees.size()&nbsp;&lt;&lt;&nbsp;endl;&nbsp;&nbsp;</span></span>
            </li>
            <li  class="alt"><span>&nbsp;&nbsp;&nbsp;cout&nbsp;&lt;&lt;&nbsp;endl&nbsp;&lt;&lt;&nbsp;<span
                        class="string">"Natural&nbsp;Order:"</span><span>&nbsp;&lt;&lt;&nbsp;endl;&nbsp;&nbsp;</span></span>
            </li>
            <li  class=""><span>&nbsp;&nbsp;&nbsp;<span class="keyword">for</span><span>(&nbsp;map&lt;</span><span
                        class="datatypes">int</span><span>,string&gt;::iterator&nbsp;ii=Employees.begin();&nbsp;ii!=Employees.end();&nbsp;++ii)&nbsp;&nbsp;</span></span>
            </li>
            <li  class="alt"><span>&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span></li>
            <li  class="">
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cout&nbsp;&lt;&lt;&nbsp;(*ii).first&nbsp;&lt;&lt;&nbsp;<span
                        class="string">":&nbsp;"</span><span>&nbsp;&lt;&lt;&nbsp;(*ii).second&nbsp;&lt;&lt;&nbsp;endl;&nbsp;&nbsp;</span></span>
            </li>
            <li  class="alt"><span>&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
            <li  class=""><span>&nbsp;&nbsp;&nbsp;cout&nbsp;&lt;&lt;&nbsp;endl&nbsp;&lt;&lt;&nbsp;<span
                        class="string">"Reverse&nbsp;Order:"</span><span>&nbsp;&lt;&lt;&nbsp;endl;&nbsp;&nbsp;</span></span>
            </li>
            <li  class="alt"><span>&nbsp;&nbsp;&nbsp;<span class="keyword">for</span><span>(&nbsp;map&lt;</span><span
                        class="datatypes">int</span><span>,string&gt;::reverse_iterator&nbsp;ii=Employees.rbegin();&nbsp;ii!=Employees.rend();&nbsp;++ii)&nbsp;&nbsp;</span></span>
            </li>
            <li  class=""><span>&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span></li>
            <li  class="alt">
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cout&nbsp;&lt;&lt;&nbsp;(*ii).first&nbsp;&lt;&lt;&nbsp;<span
                        class="string">":&nbsp;"</span><span>&nbsp;&lt;&lt;&nbsp;(*ii).second&nbsp;&lt;&lt;&nbsp;endl;&nbsp;&nbsp;</span></span>
            </li>
            <li  class=""><span>&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
            <li  class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
        </ul>
    </div>

</div>
<p><strong>Output:</strong></p>
<div class="output"><pre>Employees[104]=Deep  <br />
 <br />
Map size: 5 <br />
 <br />
Natural Order: <br />
101: Nikita <br />
102: Aman <br />
103: Dully <br />
104: Deep <br />
105: John <br />
 <br />
Reverse Order: <br />
105: John <br />
104: Deep <br />
103: Dully <br />
102: Aman <br />
101: Nikita <br />
</pre></div> <br />
 <br />
<h2 class="h2">Member Functions</h2> 
<p>Below is the list of all member functions of map:</p>
<h3 class="h3">Constructor/Destructor</h3>
<table class="alt">
<tbody><tr>
    <th>Functions</th>
    <th>Description</th>
</tr>
<tr>
    <td>constructors</td>
    <td>Construct map</td>
</tr>
<tr>
    <td>destructors</td>
    <td>Map destructor</td>
</tr>
<tr>
    <td>operator=</td>
    <td>Copy elements of the map to another map.</td>
</tr>
</tbody></table>
<h3 class="h3">Iterators</h3>
<table class="alt">
<tbody><tr>
    <th>Functions</th>
    <th>Description</th>
</tr>
<tr>
    <td>begin</td>
    <td>Returns an iterator pointing to the first element in the map.</td>
</tr>
<tr>
    <td>ocbegin</td>
    <td>Returns a const iterator pointing to the first element in the map.</td>
</tr>
<tr>
    <td>end</td>
    <td>Returns an iterator pointing to the past-end.</td>
</tr>
<tr>
    <td>cend</td>
    <td>Returns a constant iterator pointing to the past-end.</td>
</tr>
<tr>
    <td>rbegin</td>
    <td>Returns a reverse iterator pointing to the end.</td>
</tr>
<tr>
    <td>rend</td>
    <td>Returns a reverse iterator pointing to the beginning.</td>
</tr>
<tr>
    <td>crbegin</td>
    <td>Returns a constant reverse iterator pointing to the end.</td>
</tr>
<tr>
    <td>crend</td>
    <td>Returns a constant reverse iterator pointing to the beginning.</td>
</tr>
</tbody></table>
<h3 class="h3">Capacity</h3>
<table class="alt">
<tbody><tr>
    <th>Functions</th>
    <th>Description</th>
</tr>
<tr>
    <td>empty</td>
    <td>Returns true if map is empty.</td>
</tr>
<tr>
    <td>size</td>
    <td>Returns the number of elements in the map.</td>
</tr>
<tr>
    <td>max_size</td>
    <td>Returns the maximum size of the map.</td>
</tr>
</tbody></table>
<h3 class="h3">Element Access</h3>
<table class="alt">
<tbody><tr>
    <th>Functions</th>
    <th>Description</th>
</tr>
<tr>
    <td>operator[]</td>
    <td>Retrieve the element with given key.</td>
</tr>
<tr>
    <td>at</td>
    <td>Retrieve the element with given key.</td>
</tr>
</tbody></table>
<h3 class="h3">Modifiers</h3>
<table class="alt">
<tbody><tr>
    <th>Functions</th>
    <th>Description</th>
</tr>
<tr>
    <td>insert</td>
    <td>Insert element in the map.</td>
</tr>
<tr>
    <td>erase</td>
    <td>Erase elements from the map.</td>
</tr>
<tr>
    <td>swap</td>
    <td>Exchange the content of the map.</td>
</tr>
<tr>
    <td>clear</td>
    <td>Delete all the elements of the map.</td>
</tr>
<tr>
    <td>emplace</td>
    <td>Construct and insert the new elements into the map.</td>
</tr>
<tr>
    <td>emplace_hint</td>
    <td>Construct and insert new elements into the map by hint.</td>
</tr>
</tbody></table>
<h3 class="h3">Observers</h3>
<table class="alt">
<tbody><tr>
    <th>Functions</th>
    <th>Description</th>
</tr>
<tr>
    <td>key_comp</td>
    <td>Return a copy of key comparison object.</td>
</tr>
<tr>
    <td>value_comp</td>
    <td>Return a copy of value comparison object.</td>
</tr>
</tbody></table>
<h3 class="h3">Operations</h3>
<table class="alt">
<tbody><tr>
    <th>Functions</th>
    <th>Description</th>
</tr>
<tr>
    <td>find</td>
    <td>Search for an element with given key.</td>
</tr>
<tr>
    <td>count</td>
    <td>Gets the number of elements matching with given key.</td>
</tr>
<tr>
    <td>lower_bound</td>
    <td>Returns an iterator to lower bound.</td>
</tr>
<tr>
    <td>upper_bound</td>
    <td>Returns an iterator to upper bound.</td>
</tr>
<tr>
    <td>equal_range</td>
    <td>Returns the range of elements matches with given key.</td>
</tr>
</tbody></table>
<h3 class="h3">Allocator</h3>
<table class="alt">
<tbody><tr>
    <th>Functions</th>
    <th>Description</th>
</tr>
<tr>
    <td>get_allocator</td>
    <td>Returns an allocator object that is used to construct the map.</td>
</tr>
</tbody></table>
<h3 class="h3">Non-Member Overloaded Functions</h3>
<table class="alt">
<tbody><tr>
    <th>Functions</th>
    <th>Description</th>
</tr>
<tr>
    <td>operator==</td>
    <td>Checks whether the two maps are equal or not.</td>
</tr>
<tr>
    <td>operator!=</td>
    <td>Checks whether the two maps are equal or not.</td>
</tr>
<tr>
    <td>operator&lt;</td>
    <td>Checks whether the first map is less than other or not.</td>
</tr>
<tr>
    <td>operator&lt;=</td>
    <td>Checks whether the first map is less than or equal to other or not.</td>
</tr>
<tr>
    <td>operator&gt;</td>
    <td>Checks whether the first map is greater than other or not.</td>
</tr>
<tr>
    <td>operator&gt;=</td>
    <td>Checks whether the first map is greater than equal to other or not.</td>
</tr>
<tr>
    <td>swap()</td>
    <td>Exchanges the element of two maps.</td>
</tr>
</tbody></table>


</td></tr>
        </div>
    )
}

export default Cp_map
